module.exports = __webpack_public_path__ + "static/media/RA-KV0404B_02.5ce41907.png";